/* eslint-disable react/prop-types */
import * as React from 'react';

import { cn } from '~/lib/utils';

interface InputProps extends React.ComponentProps<'input'> {
  leading?: React.ReactNode;
  trailing?: React.ReactNode;
  inputClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, inputClassName, type, leading, trailing, ...props }, ref) => {
    return (
      <div
        className={cn(
          'flex w-full flex-row items-center border-b border-input px-3 py-1 text-base md:text-sm',
          className,
        )}>
        {leading}
        <input
          type={type}
          className={cn(
            'focus-visible:ring-none flex w-full bg-transparent transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
            inputClassName,
          )}
          ref={ref}
          {...props}
        />
        {trailing}
      </div>
    );
  },
);
Input.displayName = 'Input';

export { Input };
